import React, { useMemo, forwardRef, useState } from 'react';
import { Button } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Paper, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ListBasculas } from './ListBasculas';
import TablePagination from '@material-ui/core/TablePagination';
import { BiSearch } from "react-icons/bi";
import { useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    seeMore: {
        marginTop: theme.spacing(3),
    },
    box: {
        display: "flex",
    },
    spreadBox: {
        justifyContent: "space-between",
        alignItems: "center"
    },
    actionsStyles: {
        padding: 0,
        margin: 0
    },
    tableAction: {
        paddingLeft: 0,
        paddingRight: 0,
        margin: "0 auto",
        textAlign: "center",
        alignItems: "center"
    },
    tableCellWit: {
        maxWidth: '50px'
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    searchContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end', // Alinea al final (derecha)
        paddingRight: theme.spacing(1), // Agrega un poco de espacio a la derecha
    },
    searchInputContainer: {
        display: 'flex',
        borderRadius: '20px 0px 0px 20px',
        height: '32px',
        fontSize: '16px',
    },
    searchInput: {
        border: '1px solid  #b6b7b7',
        borderRadius: '20px 0px 0px 20px',
        padding: '4px 8px',
        height: '100%',
        fontSize: 'inherit',
        outline: 'none',
        flex: 1,
    },
    searchButton: {
        color: 'white',
        borderRadius: '0px 50px 50px 0px',
        padding: '8px 16px',
        fontSize: '14px',
    },
    tablePagination: {
        '& .MuiTablePagination-spacer': {
            color: theme.palette.primary.main, // Cambia el color del separador entre los íconos
        },
        '& .MuiTablePagination-caption': {
            color: theme.palette.primary.main, // Cambia el color del texto "Datos por página:"
        },
        '& .MuiIconButton-label': {
            color: theme.palette.primary.main, // Cambia el color de los íconos de siguiente y página anterior
        },
    },
}));

export const List = ({ handledEditSettings, data, reload, totalElements, handleSupervisor }) => {
    const [id_list, setid_list] = useState("");
    const theme = useTheme();

    let to = `/basculas/mediciones/${id_list}`;
    const classes = useStyles();
    const history = useHistory();
    const [busqueda, setBusqueda] = useState("");

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const renderLink = useMemo(() => forwardRef((itemProps, ref) => <RouterLink to={to} ref={ref} {...itemProps} />),
        [to],
    );


    let toUser = `/mediciones/user/${id_list}`;
    const renderUserMachineLink = useMemo(() => forwardRef((itemProps, ref) => <RouterLink to={toUser} ref={ref} {...itemProps} />),
        [toUser],
    );
    let toAlcolimetria = `/basculas/alcoholimetria/${id_list}`;
    const alcolimetriaLink = useMemo(() => forwardRef((itemProps, ref) => <RouterLink to={toAlcolimetria} ref={ref} {...itemProps} />),
        [toAlcolimetria, id_list],
    );



    const handledViewImc = (id) => {
        setid_list(id);
    };

    const handledViewUsers = (id, name) => {
        const params = {
            nameBascula: name
        };
        setTimeout(() => {
            history.push(`/mediciones/user/${id}`, params);
            setid_list(id);
        }, 500);
    };

    const handledViewAcolimetria = (id, name) => {
        const params = {
            nombre: name
        };
        setTimeout(() => {
            history.push(`/basculas/alcoholimetria/${id}`, params);
            setid_list(id);
        }, 2000);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            filtrar();
        }
    };

    const handledViewPolls = (id) => {
        history.push(`/poll/encuestas/${id}`);
        setid_list(id);
    };

    // Cambio de pagina
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        reload(busqueda, newPage, rowsPerPage);
    };

    // Cambio de tamaño
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        reload(busqueda, 0, event.target.value);
        setPage(0);
    };

    const buscador = (e) => {
        setBusqueda(e.target.value);
    };

    // Filtro
    const filtrar = () => {
        reload(busqueda, 0, rowsPerPage);
        setPage(0);
    };

    const rows = data === undefined ? [] : data;
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen(!open);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const primaryColor = theme.palette.primary.main;
    

    return (
        <>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={6}>
                    <Typography variant="h4" style={{ textAlign: 'left', fontSize: '20px', fontFamily: "'Segoe UI Variable Static Display 700', sans-serif", marginBottom: "3%" }} color='primary'>Estaciones</Typography>
                </Grid>
                <Grid item xs={6} className={classes.searchContainer} >
                    <div className={classes.searchInputContainer}>
                        <input
                            id="descripcion"
                            type="buscador"
                            name="descripcion"
                            onChange={buscador}
                            value={busqueda}
                            onKeyPress={handleKeyPress}
                            className={classes.searchInput}
                            placeholder="Buscar"
                            style={{
                                border: `1px solid ${theme.palette.primary.main}`,
                                borderRadius: '20px 0px 0px 20px',
                                padding: '4px 8px',
                                fontSize: 'inherit',
                                outline: 'none',
                                flex: 1,
                            }}
                        />
                    </div>
                    <Button onClick={filtrar} className={classes.searchButton} style={{ backgroundColor: theme.palette.primary.main }}>
                        <BiSearch />
                    </Button>
                </Grid>
            </Grid>
            <Paper>
                <ListBasculas
                    rows={rows}
                    renderLink={renderLink}
                    renderUserMachineLink={renderUserMachineLink}
                    alcolimetriaLink={alcolimetriaLink}
                    handleClick={handleClick}
                    handleClose={handleClose}
                    handledViewImc={handledViewImc}
                    handledViewUsers={handledViewUsers}
                    handledViewAcolimetria={handledViewAcolimetria}
                    handledViewPolls={handledViewPolls}
                    handledEditSettings={handledEditSettings}
                    handleSupervisor={handleSupervisor}
                />
                <TablePagination
                    className={classes.tablePagination}
                    component="div"
                    count={totalElements}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage="Datos por página:"
                    style={{ color: primaryColor }}
                />
            </Paper>
        </>
    );
};
